import Cookies from 'js-cookie'
import { CSRF_TOKEN } from 'cookies.yml'

/**
 * @return String? the current CSRF token. Will be undefined if
 *         allow_forgery_protection=false
 */
export default function csrfToken() {
  const cookieToken = Cookies.get(CSRF_TOKEN)
  if (cookieToken) return cookieToken

  const metaTag = document.getElementsByName('csrf-token')[0]
  return metaTag && metaTag.content
}
